// § 356a BGB: zweite Bestaetigungsstufe fuer das Widerrufsformular.
// Nur aktiv, wenn das Formular das versteckte Marker-Feld contact[form_type]=widerruf-356a traegt
// (gesetzt durch templates/page.vetrag-widerrufen.json). Der eigentliche Rechtsakt ist der
// POST an /contact — diese Stufe ist eine reine Client-Bestaetigung davor.
//
// Der erste Button ist bewusst type="button" (nicht type="submit"): Google Tag Manager haengt
// einen eigenen fruehen submit-Listener an (Form-Submission-Trigger, "Wait for Tags") und
// vervollstaendigt eine native Submission ueber form.submit(), was preventDefault() aus einem
// anderen Listener nicht verhindern kann. Ohne natives Submit-Event beim ersten Klick greift das
// nicht — die einzige echte Submission ist der spaetere form.requestSubmit() nach Bestaetigung.
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("form").forEach(function (form) {
    var marker = form.querySelector('input[name="contact[form_type]"][value="widerruf-356a"]');
    if (!marker) return;

    var confirmStage = form.querySelector("[data-widerruf-confirm]");
    var submitButton = form.querySelector("[data-widerruf-submit]");
    if (!confirmStage || !submitButton) return;

    var submitWrapper = submitButton.closest(".grid-span-2");

    submitButton.addEventListener("click", function () {
      submitWrapper.classList.add("hidden");
      confirmStage.classList.remove("hidden");
      confirmStage.scrollIntoView({ behavior: "smooth", block: "center" });
    });

    var confirmButton = confirmStage.querySelector("[data-widerruf-confirm-submit]");
    var backButton = confirmStage.querySelector("[data-widerruf-confirm-back]");

    confirmButton.addEventListener("click", function () {
      form.requestSubmit();
    });

    backButton.addEventListener("click", function () {
      confirmStage.classList.add("hidden");
      submitWrapper.classList.remove("hidden");
    });
  });
});
